import { useActionState, useEffect } from "react";
import IconButton from "../../../../components/icon-button";
import { TrashIcon } from "@heroicons/react/24/outline";
import { TemporaryIllness } from "../../../../models";
import { deleteTemporaryIllness } from "../actions";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export function DeleteTemporaryIllnessButton({item}:{item: TemporaryIllness}){
  const navigate = useNavigate();
  const deleteWithId = deleteTemporaryIllness.bind(null, item.id!);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this item?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteWithId, { success: false });

  useEffect(() => {
    if (state.success) {
      toast.success("Temporary illness deleted successfully");
      navigate(`/admin/temporary-illnesses?reload=${Date.now()}`, { replace: true });
    }
  }, [state.success]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending} />
    </form>
  );
}
